import { useCallback } from 'react';

import { useGetMyProfileQuery } from '@api/user';
import { Roles } from '@rdTypes/shared';

export const useUserPermissions = () => {
  const { data: currentUser } = useGetMyProfileQuery();

  const isAllowed = useCallback(
    (requiredInterface: Roles[]) => {
      const roles = currentUser ? (currentUser.roles as Roles[]) : [];

      if (roles.includes(Roles.KTAdmin)) return true;

      const filteredArray = roles.filter((value) => requiredInterface.includes(value));
      return filteredArray.length ? true : false;
    },
    [currentUser],
  );

  return { isAllowed };
};
